export default {
  upload: "上传",
  upload_file: "上传文件",
  login: "登录",
  logout: "登出",
  manage:'管理',
  recover: "恢复",
  login_with_okta: "OKTA登录",
  change_password: "修改密码",
  check_user_role: "确认用户身份中……",
  check_user_role_failed: "您无权限登录管理员端，请尝试重新登录。",
  login_again: "重新登录",
  supported_file_types: "支持的文件类型",
  preview: "预览",
  reset_pwd: "重置密码",
  create: "创建",
  batch_notice:'批量通知',
  batch_remove:'批量移除',
  export_list:'导出清单',
  send_notice:'通知',
  password: {
    old: "旧密码",
    new: "新密码",
  },
  tag: "标签",
  role_switch: "返回用户端",
  add_file: "添加章节",
  add_success: "添加成功",
  session_switch: "会议开关",
  network_space: "基本数据",
  select: "请选择",
  zoom_meeting_room: "ZOOM会议室",
  live_meeting_room: "现场会议室",
  add_room: "添加会议室",
  notice_board: "公告栏",
  notice: "公告",
  qa:'Q&A',
  template: "模板",
  copy_attendee: "复制参会人",
  copy_session: "复制会议",
  tag: "标签管理",
  company: "公司",
  'CORE':'核心',
  'NONCORE':'非核心',
  partner_pool: "用户列表",
  application: '应用',
  error: "错误",
  associated_property: "关联属性",
  recommend: "推荐",
  cover: "封面图",
  short_note: "短信通知",
  email_note: "邮件通知",
  message: "短信",

  app:{
    name:'应用名称',
    add_application:'添加应用',
    edit_application:'编辑应用',
    scene_code:'场景参数',
    scene_code_config:'场景参数配置',
    scene_code_list:'场景参数列表',
    apply_scene_code:'启用场景参数',
    add_scene_code:'添加场景参数',
    app_binding:'应用绑定',
    enable:'启用',
    disable:'未启用',
    add_edit_warn:'应用名称和url不能为空'
  },
  channel:{
    create_channel: "创建频道",
    edit_channel: "编辑频道",
    channel_name: "频道名称",
    broadcaster: "播音员",
    view_bind_session: "查看绑定会议",
    query_session_input_placeholder: "请输入活动名称/会议名称",
    query_session_date_placeholder: "请输入会议日期范围"
  },
  sport_name: "运动名称",
  sport_date: "运动日期",
  sport_item: "运动项目",
  check_in_lead_time:'提前入场时间',
  deadline: "报名截止时间",
  sport_notice: "运动公告",
  project_notice: "项目公告",
  isSigned:'是否签到',
  signed:'签到',
  not_sign:'未签到',
  location: "地点",
  tip: "温馨提示",
  peoples: "人数",

  registration_time: "报名时间",
  sport_setting: "运动管理",
  sport:{
    name: "运动",
    input_sport_name: "请输入运动名称",
    date: "日期",
    time: "时间",
    stage: "阶段",
    ready: "准备阶段",
    registration: "报名阶段",
    activity: "活动阶段",
    end: "结束阶段",
    message: {
      name: "运动名称不能为空",
      sport_date: "运动日期不能为空",
      deadline: "报名截止日期不能为空",
      appointment_time: "预约时间不能为空",
      sport_item: "运动项目不能为空"
    }
  },
  sport_detail:{
    name: "运动详情",
    item_list: "项目列表",
    item_name: "项目名称",
    check_list: "报名清单",
    sport_announcement: "运动公告",
    appraise: "评价",
    upload_wonderful_moments: "上传精彩瞬间",
    item_name: "项目名称",
    item_description: "项目介绍",
    item_date: "项目日期",
    item_time: "项目时间",
    project_introduction_image: "项目介绍图",
    score: "评分",
    message:{
      item_name: "项目名称不能为空",
      item_date: "项目日期不能为空",
      item_time: "项目时间不能为空",
      location: "地点不能为空",
      item_introduction: "项目介绍不能为空"
    }
  },
  admin: "管理员",
  playlist_types: "播单类型",
  auto_playlist: "自动播单",
  manual_playlist: "手动播单",
  chat_block_word: "敏感词管理",
  video_manage: "视频管理",
  channel_manage: "频道管理",
  event_management: "活动管理",
  bi_report: "系统报表",
  help_center: "eMoment小助手",
  event: "活动",
  recent_events: "近期活动",
  warning: "警告",
  hint: "提示",
  account_group: "客户组",
  upload_video: "上传视频",
  upload_image: "上传图片",
  view_image: "查看图片",
  time:'时间',
  answer_status:'回答状态',
  all:'全部',
  answered:'已回答',
  unanswered:'未回答',
  content:'内容',
  new_ask:'新追问',
  ask_time:'提问时间',
  snapshot:'提问截图',
  answer:'回答',
  no_resources: "暂无资源",
  general: "通用",
  playback: "重播",
  recorded: "录播",

  //活动阶段
  event_stage:{
    '准备阶段':'准备阶段',
    '注册阶段':'注册阶段',
    '活动阶段':'活动阶段',
    '活动结束':'活动结束'
  },
  event_stage_check:{
    stage_check:'活动阶段检查',
    stage_switch:'阶段切换',
    check_result:'检查结果',
    rule:'规则',
    is_passed:'是否通过',
    message:'信息',
    pass:'已通过',
    fail:'未通过',
    fixed: "已解决",
    not_fixed: "未解决",
  },
  send_all: "发送给全部参会人",
  send_already: "发送给未通知过的参会人",
  stage_check_rules:{
    "是否维护至少一个活动管理员":"是否维护至少一个活动管理员",
    "发现管理员":"发现管理员"
  },
  //相关操作
  add: "新增",
  operate: "操作",
  edit: "编辑",
  download: "下载",
  use: "应用",
  in_use: "正在应用",
  delete: "删除",
  save: "保存",
  cancel: "取消",
  submit: "提交",
  search: "搜索",
  clear: "清空条件",
  clear_result: "清空结果",
  disable: "停用",
  enable: "启用",
  detail: "详情",
  back: "返回",
  publish: "发布",
  action: "操作",
  REMOVE: "移除",
  close: "关闭",
  copy: "复制",
  on: "开",
  off: "关",
  confirm: "确认",
  sort: "排序",
  other: "其它",
  more:"更多",
  unbind: "解绑",
  inform:"通知",
  associate_meeting:"关联会议",
  associate_meeting_list:"关联会议列表",
  session_list:'会议列表',
  "i.page.total": "共",
  "i.page.items": "条",
  "i.page.item": "条",
  "i.page.goto": "跳至",
  "i.page.p": "页",
  check_report: "← 请选择并查看报表",
  help_center_detail:{
    user_manual: "用户使用手册",
    feature_description_video: "功能介绍视频",
    FAQ: "常见问题",
    search_placeholder: "请输入关键字",
    table:{
      document_name: "文档名称",
      upload_time: "上传时间",
      type: "类型",
      language_environment: "语言环境",
      state: "状态",
      action: "操作",
      question: "问题",
      answer: "回答"
    },
    document_content: "文档内容",
    document_type: "文档类型",
    user_role: "用户角色",
    document_state: "文档状态",
    document_upload: "文档上传",
    type_selection: "选择类型",
    state_selection: "选择状态",
    select_a_language_environment: "选择语言环境",
    public: "公开",
    not_public: "不公开",
    upload_pdf_tip: "支持扩展名: pdf",
    play_video: "播放视频",
    table_tip: "抱歉，没有找到相关结果。换个关键词试试",
    no_data: "暂无数据",
    no_content: "暂无内容",
    history: "历史记录",
    catalog: "目录",
    system_admin: "系统管理员",
    event_admin: "活动管理员",
    attendee: "参会人",
    broadcaster: "播音员",
    partner_contactor: "客户联络员",
    speaker: "讲者",
    assistant: "产品专家",
    general: "通用",
    faq_feedback: "问题反馈",
    enter_question: "请输入问题",
    clear_the_history: "清空历史记录",
    preparatory_phase: "准备阶段",
    registration_phase: "注册阶段",
    activity_phase: "活动阶段",
    activity_end: "活动结束",
    solve_problem: "是否解决了你的问题 ?",
    solve_problem_ok: "是，已解决",
    solve_problem_no: "否， 为解决",
    feedback: "感谢您的反馈！",
    send_email: "请将您的问题编辑后发送至",
    i_know: "我知道了"
  },

  // inform_detail: {
  //   event_message: "{name}，您好，[event]活动已开始，请尽快登录emoment.nike.com参加",
  //   session_message: "{name}，您好，[event]活动的[session]会议已开始，请尽快登录emoment.nike.com参加"
  // },

  QA:{
    answer_list:'回答列表',
    answer_user:'回答人',
    answer_content: '回答内容',
    answer_time:'回答时间',
    ask_time:'提问时间',
    ask_user:'提问人',
    content:'内容',
    answer_status:'回答状态'
  },

  meeting_room_detail: {
    start_at: "会议开始于 {time}",
    end_at: "会议结束于 {time}",
    detail: "详情",
    current_meeting: "当前会议",
    current_meeting_id: "当前会议ID",
    current_meeting_start_time: "当前会议开始时间",
    current_meeting_end_time: "当前会议结束时间",
    current_meeting_duration: "当前会议持续时间",
    booking_list: "会议室预约列表",
    event: "活动名称",
    session: "会议名称",
    session_date: "会议日期",
    session_time: "会议时间",
    meeting_history: "会议历史",
    meeting_id: "会议ID",
    meeting_date: "会议日期",
    meeting_time: "会议时间",
    meeting_duration: "会议持续时间",
    duration_time_format: "{munites}分{seconds}秒",
  },
  live_room_detail: {
    build_type: "会议室类型",
    office_building: "办公楼",
    floor: "楼层",
    session_room: "会议室名称",
    session_room_num: "会议室房间号",
    is_valid: "是否可用",
    projection: "投影仪型号",
    desk_type: "会议桌布局",
    max_attendee: "最大参会人数",
    edit_session_room: "编辑会议室",
    add_session_room: "新增会议室"
  },
  tag_list: {
    search_tag_kewords: "请输入标签选项",
    tag_title: "标签选项",
    add_tag_title: "新增标签",
    add_tag_input: "标签",
    input_tag: "请输入标签选项",
    search_company_keywords: "请输入公司名称",
    add_account_group: "新增客户组",
    add_company: "新增公司",
    company_name: "公司名称",
    relation_event: "关联活动",
  },
  company: "公司",
  company_list: {
    code: "客户组代码",
    name: "客户组名称",
    add_company: "新增客户组",
    enter_code: "请输入客户组代码",
    enter_name: "请输入客户组名称",
  },
  user: {
    phone: "手机",
    email: "邮箱",
    LOCATION: "区域",
    COMPANY: "公司",
    account_group: "客户组",
    CITY: "城市",
    account: "账号",
    password: "密码",
    name: "姓名",
    clear_openid: "清空OPENID",
    disabled: "已停用",
    enabled: "已启用",
    prefix: "区号",
    gender: "性别",
    is_disabled: "账号是否停用",
    is_internal: "内部员工",
    only_internal: "仅显示内部员工",
    without_internal: "不显示内部员工",
    TAG1: "分类",
    TAG2: "品类",
    TAG3: "性别",
    TAG4: "自定义标签1",
    TAG5: "自定义标签2",
    is_main_owner: "活动拥有者",
    is_owner: "活动管理员",
    is_partner_contact: "客户联络员",
    approve_by_pc: "客户联络员",
    approve_by_pc_time: "客户联络员审批时间",
    approve_by_ea: "活动管理员",
    approve_by_ea_time: "活动管理员审批时间",
  },
  user_list: {
    download_template: "下载用户模板",
    upload_user: "上传用户列表",
    add_user: "新增用户",// 新增用户
  },
  videoManage: {
    video_manage: "视频管理",
    upload_video: "上传视频",
    merge_video: "合并视频",
    merge_chapter: "合成章节",
    choose_video: "选择视频",
    video_name: "视频名称",
    upload_time: "上传时间",
    tags: "标签",
    relation: "关联",
    season: "季节",
    account_group: "客户组",
    add: "添加",
    confirm: "确定",
    remove: "移除",
    merge: "合成",
    associate_session_input: "请输入活动名称或会议名称",
    session_start_time: "会议开始时间",
    session_end_time: "会议结束时间",
    disassociation: "解除关联",
    select_associated_property: "选择关联属性"
  },

  event_detail: {
    search_event_placeholder: "请输入活动名称",
    send_agenda: "发送日程",
    whether_to_show: "是否展示",
    video_title: "视频标题",
    broadcaster: "播音员",
    add_broadcaster: "绑定播音员",
    partner_contact: "客户联络员",
    start: "开始活动",
    end: "结束活动",
    delete_notice: "如您需要删除活动，请先“停止活动”。",
    name: "活动名称",
    account_group: "客户组",
    start_time: "开始时间",
    end_time: "结束时间",
    invitation_url: "邀请链接",
    ADD_INVITATION: "添加邀请",
    is_active: "是否开始",
    active: "开始活动",
    inactive: "结束活动",
    active_status: "活动已开始",
    inactive_status: "活动未开始",

    add: "新增活动",
    date: "活动日期",
    export_active_chat_record: "导出活动聊天记录",
    export_session_chat_record: "导出会议聊天记录",
    select_date_range: "请选择日期范围",
    detail: "活动详情",
    add_event_admin: "新增活动管理员",
    add_partner_contact: "新增客户联络员",
    switch_platform_notification: "平台切换信息",
    switch_platform_minutes: "切换平台倒计时",
    switch_platform_time: "切换平台确切时间",
    switch_platform_preview: "预览",
    support_extensions: "支持的扩展名: {extensions}",
    countdown_template: "倒计时模板",
    video_cover: "视频封面{index}",
    upload_video_cover_tip: "上传视频封面",
    seasonal_video: "视频-{index}",
    seasonal_image: "图片-{index}",
    switch_platform_preview_detail: "eMoment系统出现问题，我们将于{minutes}分钟后({time})在备用系统继续进行会议，请通过网址：{url} 登录系统继续参会。我们很抱歉为您带来不便。",
    send_switch_platform_notification: "发送平台切换信息",
    tab: {
      "dashboard": "活动报表",
      "report": "报表",
      "event_detail": "活动详情",
      "sessions": "会议",
      "attendees": "参会人",
      "event_admin": "活动工作人员",
      "speakers": "讲者",
      "assistants": "产品专家",
      "speakers/assistants": "讲者与产品专家",
      "invitation": "活动邀请",
      "notify": "站内信",
      "log": "活动日志",
      "channels": "直播频道",
      "forecast_of_assets": "预告资产",
      "approval_list": "审批表",
      "advance": "高级设置",
      "notice": "公告",
      "qa":"Q&A",
      "产品库":"产品库",
      "MDTF": "MDTF"
    },
    notice: {
      notice_type: "公告类型",
      event: "活动公告",
      session: "会议公告",
      choose_session: "选择会议",
      title: "标题",
      input_title: "请输入公告标题",
      content: "内容",
      publisher: "发布人",
      is_draft: "是否发布",
      due_time: "公告时间",
      reminder_type: "公告方式",
      silence: "隐式推送",
      popup: "弹窗推送",
      with_email_phone: "短信/邮件",
      send_immediately: "立即发送",
      appointment_time: "预约时间",
      media: "附件",
      upload_media: "上传附件",
      download_accessory: "下载附件",
    },
    chart: {
      "attendee_status": "参会人状态",
      "session_type": "会议类型",
      "online_session": "在线会议",
      "registration_qty": "注册人数",
      "daily_login_qty": "每日登录人数",
      "daily_session_qty": "每日会议数量",
      "session_avg_qty": "平均每场人数",
    },
    report: {
      title: "数据报表",
      last_time_at: "截止统计时间：{time}",
      export: "导出报表",
      refresh: "刷新",
      pc_approval: "Partner Contact 审批情况",
      register_table: "注册表",
      register_table_approved: "一审已通过",
      register_table_rejected: "一审已拒绝",
      register_table_wait: "一审未操作",
      approve_table: "审批表",
      approve_table_left: "邀请剩余名额",
      login_table: "登录表",
      login_table_login: "已登录参会人",
      login_table_not_login: "未登录参会人",
      approve_status: "审批状态",
      event_login: "Event 登录情况",
      actual_login: "实际登录用户数",
      no_login: "没有登录数",
      session_login: "Session 登录情况",
      session_login_description: "从开始时间统计会议累计的登录人数，数据略有延迟。",
      real_time_login: "实时登录情况",
      real_time_login_description: "从【{time}】开始，5分钟内登录数据。",
      account_group_login: "Account Group 登录情况",
      company_login: "Company 登录情况",
      user_status: "参会人状态统计",
      join_status: "参会状态",
      no_join_status: "登录状态",
      no_company: "无公司",
    },
    main_title_image: "活动主题图",
    banner: "活动BANNER-{number}",
    poster_event_broadcast_image: "直播背景图",
    poster_event_countdown_image: "倒计时背景图",
    poster_event_register_image: "注册界面图",
    image_size: "- 图片尺寸：{size}",
    cropper_image_size: "图片尺寸: {width} * {height}",
    compress_image_size: "压缩后的图片大小: {size} KB",
    upload_image_comments: "点击上传或拖拽图片到此处",
    upload_file_comments: "点击上传或拖拽文件到此处",
    session_default_image: "会议默认图片",
    notify: "站内信",
    add_notify: "新增站内信",
    notify_title: "站内信标题",
    notify_is_published: "发布状态",
    notify_is_publish: "是否发布",
    notify_success: "站内信发布成功",
    notify_content: "站内信内容",
    notify_published: "站内信已发布",
    notify_unpublished: "站内信未发布",
    // 会议tab相关
    add_session: "新增会议",
    download_session_template: "下载会议模板",
    upload_sessions: "上传会议",
    advanced_options: {
      playback_switch: "重播开关",
      video_list: "视频列表",
      session_protect: "会议保护",
      remove_protect: "解除保护",
      hint_session_protect: "确认保护 [{session_name}] 会议?",
      hint_remove_protect: "确认解除保护 [{session_name}] 会议?",
      title: "高级设置",
      session_title: "[{session_name}] 高级设置",
      video_management: "视频管理",
      activity_introduction: "活动介绍",
      activity: "活动",
      video_management_info: "点击或将视频拖拽到这里上传",
      video_management_Tip: "支持扩展名: .mp4, .mov（1080P及以上）",
      upload_file_add: "添加文件成功",
      upload_file_choose: "请选择需要上传的文件!",
      upload_file_mp4: "请选择mp4或mov格式的文件!",
      upload_file_success: "文件上传成功",
      upload_file_failed: "文件上传失败",
      upload_file_loading1: "文件上传中...",
      upload_video_loading: "视频上传中...",
      upload_file_timeout: "文件上传超时！",
      upload_isUploading: "有文件在上传!",
      upload_cancel_title: "有文件在上传，确定取消吗？",
      update_success: "更新成功",
      delete_success: "删除成功",
      upload_success: "上传成功",
      try_later: "视频转码中，请稍后重试",
      upload_failed_canResume: '上传失败，点击续传',
      upload_failed: '上传失败',
      add_video: "+添加视频",
      add_subtitle: "+添加字幕",
      add_section: "添加章节",
      delete_section: "删除章节",
      section: "章节",
      section_name: "章节名称",
      download_chapter_template: "下载章节模板",
      upload_chapter_template: "上传章节模板",
      chapter_template: "章节模板",
      upload_file_subtitle: "请选择vtt或ass格式的文件!",
      add_subtitle_success: "添加字幕成功",
      basic_setting: "基本设置",
      is_open: "是否开启",
      time_can_not_empty: "时间不能为空",
      time_error0: "开始时间不能小于当前时间",
      time_error: "开始时间不能大于结束时间",
      not_support_video: "您的浏览器不支持视频播放",
      get_speaker_ingest_address: "获取讲者推流地址",
    },
    attendee: "参会人",
    attendee_count: "参会人数量",
    attendee_copy_to: "复制到",
    attendee_copy: "参会人复制",
    add_to_session: "添加至会议",
    attendee_to_session: "参会人添加至会议",
    add_attendee_to_session: "将[{attendee_name}]添加至下方会议中",
    confirm_add_attendee_to_session: "确认将[{attendee_name}]添加到右侧已选择的会议中？",
    choose_copy_attendee_to: "选择会议",
    copy_attendee_from: "从[{session_name}]复制参会人到下方会议中",
    upload_session_attendees: "上传参会人",
    download_session_attendee_template: "下载参会人模板",
    download_all_attendee:"下载全部的参会人",
    add_attendee_from_attendees: "从参会人列表添加",
    add_attendee_from_users: "从用户列表添加",
    select_all_pre: "已勾选本页{count}个参会人，",
    select_allUser_pre: "已勾选本页{count}个用户，",
    select_all_suf: "勾选参会人列表中全部的{count}个参会人",
    select_allUser_suf: "勾选用户列表中全部的{count}个用户",
    select_all_suf1: "已勾选参会人列表中全部的{count}个参会人，",
    select_allUser_suf1: "已勾选用户列表中全部的{count}个用户，",
    cancel_select: "取消勾选",
    session_attendee_title: "[{session_name}]参会人",
    has_channel: "直播频道",
    // 频道tab
    channel_name: "频道名称",
    session_count: "会议计数",
    view_related_session: "查看关联会议",
    // 参会人tab
    invitation_status: "邀请状态",
    registration_status: "审批状态",
    IS_CONFIRMED: "接受状态",
    approve: "同意",
    reject: "拒绝",
    confirmed_status: {
      "PENDING": "待定",
      "CONFIRMED": "确认",
      "REJECTED": "拒绝"
    },
    IS_BLOCK: "账号可用",
    online_onsite: "线上/现场",
    online: "线上",
    onsite: "现场",
    approval_list: "审批表",
    download_approval_list: "下载审批表",
    upload_approval_list: "上传审批表",
    // 讲者tab
    ADD_SPEAKER: "添加讲者",
    ADD_ASSISTANT: '添加产品专家',
    invitation_speaker: "邀请讲者",
    invitation_assistant: "邀请产品专家",
    is_speaker: "讲者",
    is_assistant: "产品专家",
    // 新增event admin
    add_event_admin: "新增活动管理员",
    // 会议信息/邀请tab
    ADD_MESSAGE_INVITATION: "添加消息/邀请",
    TITLE: "标题",
    SCHEDULE_TIME: "指定时间",
    LAST_UPDATE_TIME: "上次更新时间",
    SEND_STATUS: "发送状态",
    START_SEND: "开始发送",
    // 活动日志tab
    EXPORT_EVENT_LOG: "导出活动日志",
    USER_NAME: "用户名",
    IP: "IP地址",
    LOG_TYPE: "日志类型",
    LOG_TIME: "记录时间",
    MESSAGE: "消息",
    invite_event_admin: "邀请活动管理员",
    invite_partner_contact: "邀请客户联络员",
    season: "季节",
    event_stage:'活动阶段'
  },

  forecast_of_assets:{
    assets_name: "资产名称",
    upload_time: "上传时间",
    assets_type: "资产类型",
    video: "视频",
    image: "图片",
    set_the_cover: "设置封面",
    view: "查看"
  },

  invitation: {
    owner: "客户联络员",
    limit: "人数限制",
    expired_time: "过期时间",
    resend_invitation: "重发邀请码",
  },

  // session_detail页面
  session_detail: {
    SESSION_TYPE: "会议类型",
    enter_session_name: "请输入会议名称",
    select_session_date: "请选择会议日期",
    select_session_time: "请选择会议时间",
    select_speaker: "请选择讲者",
    select_assistant: "请选择产品专家",
    confirm_copy_attendee_to_session: "确认将[{session_name}]会议中的所有参会人复制到右侧已选择的会议中吗",

    playback_time: "重播时间",
    preview_time: "预览时间",
    session_type_detail: {
      ONSITE: "现场会议",
      BROADCAST: "直播会议",
      "INTERACTIVE MEETING": "互动会议",
      PLAYBACK: "重播会议",
      RECORDED: "录播会议",
      BROADCAST_CASTER: "连麦会议",
      ACTIVITY: "活动会议",
    },
    activity_status: "活动是否结束",
    approach_time: "进场时间",
    select_enter_time: "请选择进场时间",
    early_enter: "提前{minutes}分钟",
    ADD_SESSION: "新增会议",
    edit_session: "会议详情",
    SESSION_DESCRIPTION: "会议描述",
    SESSION_COMPANY: "客户组",
    SPEAKER: "讲者",
    WHITEBOARD: "白板",
    WATERMARK: "水印",
    WATERMARK_TYPE: "水印样式",
    SESSION_HOME_IMAGE: "会议图片",
    session_countdown_image: "倒计时背景图",
    BROADCAST: "直播",
    RECORDED: "录播",
    BROADCAST_IMAGE: "直播背景图",
    ZOOM_CONFIG: "ZOOM配置",
    ALIYUN_PUSH_ADDRESS: "阿里云地址",
    BROADCAST_IS_START: "直播是否开始",
    ENABLE_PARTICIPANT_VIDEO: "用户视频",
    IS_WEBINAR: "研讨会",
    ENABLE_SCREEN_SHARING: "用户桌面分享",
    ENABLE_WAITING_ROOM: "启用等待室",
    ENABLE_JOIN_BEFORE_HOST: "提前加入会议室",
    JOIN_BEFORE_HOST_TIME: "提前加入时间",
    ANYTIME: "任何时间",
    BEFORE_5min: "提前5min",
    BEFORE_10min: "提前10min",
    choose_channel: "选择直播线路",
    new_channel: "新增直播频道",
    choose_channel_input: "频道名称",
    new_channel_name: "频道名称",
    default_watermark: "水印分布: 5*3, 透明度: 50%",
    zoom_watermark: "水印分布: 7, 6, 7, 透明度: 50%",
    watermark_9_4: "水印分布: 9*4, 透明度: 50%",
    video_name: "视频名称",
    video_duration: "视频时长",
    activity_media: "活动内容",
  },

  update_me: {
    get_code: "获取验证码",
    count_down: "{second}秒后重试",
  },

  register: {
    division: "分类",
    category: "品类",
    gender: "性别",
    tag1: "分类",
    tag2: "品类",
    tag3: "性别",
    tag4: "自定义标签1",
    tag5: "自定义标签2",
    confirm_user_information: "确认用户信息",
    name: "姓名",
    gender: "性别",
    select_gender: "请选择性别",
    male: "男",
    female: "女",
    phone: "手机号",
    old_phone: "原手机号",
    new_phone: "新手机号",
    old_email: "原邮箱",
    new_email: "新邮箱",
    validation_code: "验证码",
    get_validataion_code: "获取验证码",
    enter_validation_code: "请输入验证码",
    change: "更改",
    email: "邮箱",
    upload_avatar: "上传头像",
    account_group: "客户组",
    select_account_group: "请选择客户组",
    area: "区域",
    city: "城市",
    company: "公司",
    online: "线上",
    onsite: "现场",
    online_onsite_description: "该选项支持多选。<br/>但请根据您的情况，选择参会的方式。",
    language: "语言",
    select_language: "请选择语言",
    register: "注册",
    input_phone: "手机号",
    input_name: "姓名",
    input_email: "邮箱",
    input_city: "输入城市",
    select_divistion: "选择分类",
    select_category: "选择品类",
    select_tag_gender: "选择性别",
    select_company: "选择公司",
    input_location: "输入地区",
    privacy: "我同意耐克的<a class='privacy_link' href='/Privacy' target='_blank'>隐私政策</a>",
    reg_pending_name: "亲爱的{user_name}，",
    reg_pending: "您已申请参加【{event_name}】，请等待客户联络员/活动管理员批准。",
    update_form: "更新用户注册信息",
  },

  // invitationdetail 页面
  invitation_detail: {
    TITLE: "标题",
    MESSAGE: "消息",
    EVENT: "活动",
    SESSION: "会议",
    SCHEDULE_DATETIME: "预定时间",
    SELECT_DATE_AND_TIME: "选择日期与时间",
    STATUS: "状态",
    CONTENT: "内容"
  },

  // sensitive word page
  sensitive_list: {
    title: "敏感词",
    download_template: "敏感词模板",
    upload: "上传敏感词",
    keyword: "关键词",
    add: "添加敏感词",
    no_sensitive_word_list: "敏感词须通过搜索后展示",
  },

  // admin list
  admin_list: {
    title: "管理员列表",
    add: "新增管理员",
    name: "姓名",
    phone: "手机号",
    email: "EMAIL",
    role: "权限",
    admin: "系统管理员",
    event_admin: "活动管理员",
    as_admin: "设为管理员",
    as_event_admin: "设为活动管理员",
    delete_success: "删除成功！",
  },

  // report viewer list
  report_viewer: {
    title: "报表浏览者",
    report_viewer: "报表浏览者",
    company_group:'客户组',
    add: "新增报表浏览者",
    add_view_company:"添加报表查看权限",
    name: "姓名",
    phone: "手机号",
    email: "EMAIL",
    role: "权限",
    delete_success: "删除成功！",
    as_report_viewer: "设为报表浏览者",
  },

  //错误提醒
  errMsg: {
    "chapter type error": "章节类型只能输入 SKU/内容 !",
    "file error": "{name} 文件格式不正确!",
    "the uploaded image cannot exceed 500kb": "上传的图片不能超过{size}!",
    "the image you uploaded is not in the right format": "您上传的图片格式不对, 图片仅支持:jpg、png、jpeg格式!",
    "unauthorized": "登录超时，请重新登录。",
    "the session room name must be unique": "会议室名称不可重复。",
    "the session room name cannot be empty": "会议室名称不能为空。",
    "the session room number must be unique": "会议室房间号不可重复。",
    "meeting room name and room number cannot be repeated": "会议室名臣不能与会议室房间号重复。",
    "the session name must be unique": "会议名称不可重复。",
    "the session time must be unique": "会议时间不可重复。",
    "session date allow empty": "会议日期不能为空。",
    "company code not allow empty": "客户组代码不能为空。",
    "company name not allow empty": "客户组名称不能为空。",
    "document type allow empty": "文档类型不能为空。",
    "document state allow empty": "文档状态不能为空。",
    "document name allow empty": "文档名称不能为空。",
    "document content allow empty": "文档内容不能为空。",
    "question allow empty": "问题不能为空。",
    "answer allow empty": "回答不能为空。",
    "event stage allow empty": "活动阶段不能为空。",
    "you need to upload a file in order to submit": "您需要上传一个视频才能进行提交。",
    "language environment allow empty": "语言环境不能为空。",
    "company name or company code may be duplicates.": "客户组或名称系统中已存在。",
    "this company in use.": "该客户组使用中，无法删除。",
    "this company not available": "该客户组不存在。",
    "this room is in use and cannot be deleted": "该会议室正在使用, 不能被删除",
    "company name cannot be duplicates": "客户组名称系统中已存在。",
    "please complete your personal info": "请完善您的个人信息。",
    "incorrect email format": "邮箱格式不正确。",
    "wrong file format": "文件格式错误。",
    "no file, or format is in correct": "未上传文件，或者文件格式错误。",
    "name not allow empty": "用户姓名不能为空。",
    "channel name not allow empty": "频道名称不能为空。",
    "no_phone": "手机号不能为空。",
    "room name cannot be empty": "会议室名称不能为空。",
    "room number cannot be empty": "会议室房间号不能为空。",
    "build type cannot be empty": "会议室类型不能为空。",
    "building cannot be empty": "办公楼不能为空。",
    "floor cannot be empty": "楼层不能为空。",
    "no_email": "邮箱不能为空。",
    "no_validation_code": "验证码不能为空。",
    "wrong validation code, please check it again.": "验证码错误，请重新检查您的验证码。",
    "phone existed": "手机号已存在。",
    "email existed": "邮箱已存在。",
    "account existed": "账号已存在。",
    "acount/pwd, phone, email not allow all empty": "账号/密码、手机、邮箱不能为空。",
    "no user": "未找到该用户。",
    "unable find user": "无法找到用户。",
    "no file found or file type error": "未上传文件，或上传文件类型错误。",
    "convert cartoon error": "转化卡通头像失败。",
    "old/new password can\'t be empty": "新/旧密码均不能为空。",
    "wrong old password": "旧密码错误。",
    "event name can not be empty": "活动名称不能为空。",
    "event start date or end date can not be empty": "活动的开始/结束日期不能为空。",
    "notify title not empty": "站内信标题不能为空。",
    "notify content not empty": "站内信内容不能为空。",
    "OKTA_Login_Fail": "OKTA登录失败，请尝试再次登录。",
    "account group can not be empty": "客户组不能为空！",
    'existed role': "该用户已经拥有此权限！",
    "no channel": "未找到该直播频道！",
    "channel in use": "该直播频道无法删除，因为它与会议绑定！",
    "event owner cannot be partner contact": "这个用户已经是活动管理员，无法再设置成客户联络员。",
    "NAME AND EMAIL CANNOT BE EMPTY.": "姓名与邮箱不能为空。",
    "name, phone, email, company required": "姓名，手机号和邮箱不能为空。",
    "invitation_owner_required": "邀请码的客户联络员不能为空。",
    "invitation_limit_required": "邀请码的上限人数不能为空。",
    "invitation_expired_time_required": "邀请码的有效期不能为空。",
    "invitation_company_required": "邀请码的公司不能为空。",
    "sensitive_word_cannot_empty": "敏感词不能为空。",
    "event_name_required": "活动名称不能为空。",
    "start_end_time_required": "会议开始时间和结束时间不能为空。",
    "playback_time_required": "重播时间不能为空。",
    "start_time_required": "会议开始时间不能为空。",
    "end_time_required": "会议结束时间不能为空。",
    "diff_playback_time": "会议结束时间必须大于会议开始时间",
    "the_start_time_must_be_different_from_the_end_time": "开始时间不能与结束时间重复。",
    "sensitive_word_duplicated": "敏感词不能重复。",
    "no attendee need to approve": "暂无需要审核的参会人。",
    "nike_email_format_error": "邮箱格式错误。",
    "email_format_error": "邮箱格式错误。",
    "no room for this session.": "当前日期暂时没有足够的会议室。",
    "already partner contact": "该用户已经是客户联络员。",
    "no role to delete event": "没有权限删除该活动。",
    "partner_contact_no_nike_email": "请勿邀请耐克同事担任客户联络员。",
    "must_nike_email": "请输入耐克邮箱。",
    "name, email, account_group required": "姓名，邮箱以及客户组为必填项。",
    "not_nike_email_phone_required": "手机号为必填项。",
    "session_name_required": "会议名称为必填项。",
    "session_assistant_required": "产品专家为必选项",
    "session_speaker_required": "讲者为必选项。",
    "broadcast_channel_required": "直播频道为必填项。",
    "no_pc_in_invitation": "该邀请未绑定客户联络员。",
    "this session already contains this attendee": "已在此会议中！",
    "tag_value existed": "标签选项已存在。",
    "phone, email not allow all empty": "手机号、邮箱不能都为空！",
    "switch_platform_required": "分钟数与时间不能为空。",
    "unable to parse the file.": "无法分析该文件。",
    "company code existed": "客户组代码已存在",
    "tag value duplicated.": "标签已存在!",
    "no_session_selected": "请选择会议！",
    "no_attendee_selected": "请选择参会人！",
    "this speaker is already existed": "讲者已存在",
    "failed to upload template": "上传模板失败！",
    "notice title allow empty": "公告标题不能为空。",
    "file_document_error": "{file_name}的文件类型不允许上传",
    "file_document_size_error": "{file_name}的文件大小超过限制",
    "upload the media fail": "上传附件失败。",
    "file_size_error": "上传文件大小不能超过{file_size}。",
    "scene_code_error":"场景参数不能为空",
    "Video name can not be empty": "视频名称不能为空",
    "Video cannot be deleted": "当前视频已绑定会议，请解绑后删除",
    "answer required":"回答不能为空",
    "no chat history":"没有聊天记录",
    "not registrable":"已超过报名截止时间，不可以再次添加用户",
    "the session time cannot be within the preview time": "会议开始时间必须大于预览结束时间",
    "the start time of the playback must be later than the end time of the session": "重播开始时间必须大于会议结束时间",
    "sport_time_error": "运动开始时间必须大于报名的结束时间",
    "sport_time_error_by_today": "运动开始时间必须大于今天"
  },
  //成功提醒
  successMsg: {
    "created success": "创建成功!",
    "merge success": "合成成功",
    "open success": "开启成功!",
    "close success": "关闭成功!",
    "association success": "关联成功!",
    "disassociation success": "解除关联成功!",
    "reset password successfully": "重置密码成功！",
    "send success": "提示已发送成功，5分钟内将不再提示！",
    "update_qa_success":'更新Q&A成功',
    "change company name successfully": "修改客户组名称成功！",
    "upload success": "上传成功！",
    "delete section successfully": "删除章节成功!",
    "set cover successfully": "设置封面成功！",
    "upload the session successfully": "上传会议成功！",
    "upload the section successfully": "上传章节成功！",
    "upload the media successfully": "上传附件成功！",
    "add company successfully": "新增客户组成功！",
    "delete company successfully": "删除客户组成功！",
    "update user successfully": "更新用户成功！",
    "add user successfully": "添加用户成功！",
    "send_email_validation_success": "验证码已发送到您的邮箱, 请注意查收!",
    "import user list successfully": "导入用户列表成功！",
    "clear openid successfully": "清空OPENID成功！",
    "update notify successfully": "更新站内信成功！",
    'update success': "更新成功！",
    "add notify successfully": "新增站内信成功！",
    "upload sensitive word success": "上传敏感词列表成功！",
    "add sensitive word successfully": "添加敏感词成功！",
    "update event successfully": "更新活动成功!",
    "delete_admin_success": "删除管理员成功！",
    "copy event invitation url successfully": "复制邀请链接成功！",
    "copy aliyun push address successfully": "复制推流地址成功！",
    "delete_event_success": "删除活动成功！",
    "delete_event_admin_success": "删除活动管理员成功！",
    "delete_report_viewer_success": "删除报表浏览者成功！",
    "copy_attendee_success": "复制参会人成功！",
    "add_to_session_success": "添加至会议成功！",
    "copy_session_success": "复制会议成功！",
    "session_protect_success": "会议保护成功！",
    "remove_protect_success": "成功解除会议保护！",
    "add_session_success": "新增会议成功！",
    "update_session_success": "更新会议成功！",
    "delete_channel_success": "删除直播频道成功！",
    "ADD PARTNER CONTACT SUCCESSFULLY.": "新增客户联络员成功！",
    "delete_partner_contact_success": "删除客户联络员成功！",
    "INVITE EVENT ADMIN SUCCESSFULLY.": "邀请活动管理员成功！",
    "ADD EVENT ADMIN SUCCESSFULLY.": "新增活动管理员成功！",
    "INVITE PARTNER CONTACT SUCCESSFULLY.": "邀请客户联络员成功！",
    "add_invitation_success": "创建邀请码成功！",
    "edit_invitation_success": "编辑邀请码成功！",
    "resend_invitation_success": "重发邀请码成功！",
    "INVITE SPEAKER SUCCESSFULLY.": "邀请讲者成功！",
    "INVITE ASSISTANT SUCCESSFULLY.": "邀请产品专家成功!",
    "delete_success": "删除成功！",
    "add_success": "新增成功！",
    "edit_success": "编辑成功！",
    "send_success": "发送成功！",
    "add_admin_success": "设置管理员成功!",
    "add_event_admin_success": "设置活动管理员成功!",
    "add_report_viewer_success": "设置报表浏览者成功!",
    "create_session_room_success": "添加会议室成功!",
    "update_session_room_success": "更新会议室成功!",
    "delete_session_room_success": "删除会议室成功!",
    "send_switch_notification_success": "发送切换平台消息完成!",
  },
  // 警告提醒
  warningMsg:{
    "there is currently no video for this document": "该文档暂时没有视频！",
    "you have not selected participants to notify": "您还未选择需要通知的参会人！",
    "check out the synthetic results": "请查看合成结果!",
    "total video duration should be shorter than session duration":"视频总时长不能大于会议时长"
  },
  //提示信息
  confirmMsg: {
    "reset_pwd": "你没有密码, 不能进行密码重置",
    "whether to send the schedule of event to the participants by email":"是否将[{event}]活动的日程以邮件形式发送给参会人?",
    "confirm that it matches the meeting content": "视频为录制内容，请确认该视频与会议内容相符",
    "confirm linking meeting to video": "确认将 [{session}] 会议关联至视频?",
    "confirm linking video to session": "确认将 [{video}] 视频关联至会议?",
    "you cannot recover company while you deleted": "客户组信息删除后，将无法恢复。",
    "do you confirm clear openid": "确认清空该用户的OPENID吗？",
    "confirm_delete_admin.admin": "确认清除该用户的系统管理员权限吗？",
    "confirm_delete_admin.event_admin": "清除活动管理员权限同时会将其活动中的权限一起清除，且该操作不可逆，确认要清除吗？",
    "confirm_delete_admin.report_viewer": "确认清除该用户的报表浏览者权限吗？",
    "confirm_delete_event": "确认删除该活动吗？",
    "confirm_delete_event_admin": "确认删除该【活动管理员】吗？",
    "confirm_delete_channel": "确认删除该直播频道吗？",
    "confirm_delete_partner_contact": "确认删除该【客户联络员】吗？",
    "confirm_delete_speaker": "你确认要删除这个讲者吗？",
    "confirm_delete_assistant": "你确认要删除这个助理吗？",
    "confirm_delete_attendee": "你确认要删除这个参会者吗？",
    "confirm_delete_session": "你确认要删除这个会议吗？",
    "confirm_publish_notify": "你确认发布这个通知吗？",
    "confirm_refresh_account": "你确认刷新这个会议室帐户吗？",
    "confirm_delete_tag": "你确认要删除这个标签选项吗？",
    "confirm_send_switch_notification": "你确认要想该活动下所有参会人发送切换平台通知吗？",
    "select_all_confirm": "确认将全部参会人添加到会议？",
    "select_allUser_confirm": "确认将全部用户添加到会议？",
    "session_protect": "该活动中有被保护的会议,请联系活动拥有者,解除会议保护后再进行删除!",
    "confirm_delete_live_meeting_room": "你确认要删除 [{live_meeting_room}] 这个会议室吗?",
    "confirm_delete_the_medial": "你确认要删除该{medial_type}吗?",
    "confirm_delete_account_group": "你确认要删除 [{account}] 这个客户组吗?",
    "confirm_delete_company": "你确认要删除 [{company}] 这个公司吗?",
    "confirm_delete_notice": "你确认要删除[{name}]这个公告吗？",
    "confirm_not_have_KIT": "请管理员确认上传附件不涉及KIT内容！",
    "confirm_delete_vod": "你确认要删除 [{vod}] 这个视频吗?",
    "unbind session confirm": "你确定要将 [{session}] 会议与 [{channel}] 频道解绑吗?",

  },
  check_rules:{
    '活动工作人员':'活动工作人员',
    '会议邀请':'会议邀请',
    '活动详情':'活动详情',
    '参会人':'参会人',
    '讲者':'讲者',
    '会议':'会议',
    '是否维护至少一个活动管理员':'是否维护至少一个活动管理员',
    '是否添加会议邀请':'是否添加会议邀请',
    '邀请人数是否少于50人':'邀请人数是否少于50人',
    '邀请有效期是否超过活动结束日期':'邀请有效期是否超过活动结束日期',
    '点击“重新发送邀请码”的次数':'点击“重新发送邀请码”的次数',
    '是否维护预告视频':'是否维护预告视频',
    '是否维护预告图片':'是否维护预告图片',
    '所有审批表内的人员状态是否无“待定”':'所有审批表内的人员状态是否无“待定”',
    '所有审批表内的人员是否选择至少一个“参会方式”':'所有审批表内的人员是否选择至少一个“参会方式”',
    '参会人/所有参会人是否都维护了会议':'参会人/所有参会人是否都维护了会议',
    '参会人/所有参会人的会议类型是否与参加权限匹配（线上/现场）':'参会人/所有参会人的会议类型是否与参加权限匹配（线上/现场）',
    '参会人是否少于50人':'参会人是否少于50人',
    '讲者是否关联至少一个会议':'讲者是否关联至少一个会议',
    '会议日期是否在活动期间':'会议日期是否在活动期间',
    '会议/会议通用检查/会议时间是否早于9:00':'会议/会议通用检查/会议时间是否早于9:00',
    '会议/会议通用检查/会议时间是否晚于18:00':'会议/会议通用检查/会议时间是否晚于18:00',
    '会议的参会人是否少于50人':'会议的参会人是否少于50人',
    '现场会议-参会人数是否大于会议室容纳人数':'现场会议-参会人数是否大于会议室容纳人数',
    '是否在直播会议中维护了线下会议室':'是否在直播会议中维护了线下会议室',
    '是否在直播会议中维护了提前进场时间':'是否在直播会议中维护了提前进场时间',
    '参会人参加会议的权限是否与参加会议类型匹配':'参会人参加会议的权限是否与参加会议类型匹配',
    '是否在录播会议中维护了线下会议室':'是否在录播会议中维护了线下会议室',
    '是否在录播会议中维护了提前进场时间':'是否在录播会议中维护了提前进场时间',
    '是否在互动会议中维护了线下会议室':'是否在互动会议中维护了线下会议室',
    '是否在互动会议中维护了提前进场时间':'是否在互动会议中维护了提前进场时间',
    '不确定会议室时可维护为TBD选项':'不确定会议室时可维护为TBD选项',
    '产品专家必填':'产品专家必填',
    '水印是否开启':'水印是否开启',
    '是否选择直播线路':'是否选择直播线路',
    '是否绑定频道':'是否绑定频道',
    '同一频道内是否存在时间冲突的会议安排':'同一频道内是否存在时间冲突的会议安排',
    '录播、重播会议视频时长是否大于会议时长':'录播、重播会议视频时长是否大于会议时长',
    '互动会议是否分配会议室':'互动会议是否分配会议室',
    '讲者邮箱是否为@nike.com':'讲者邮箱是否为@nike.com',
    '详情中是否上传会议视频':'详情中是否上传会议视频',
    '是否上传字幕':'是否上传字幕',
    '重播会议是否开启重播':'重播会议是否开启重播',
    '是否维护重播时间':'是否维护重播时间'
  }

}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn.js